import { TrackingData } from "./TrackingEvent";

// Lead Source parameters we capture from the embedded form.
export interface LeadSourceTrackingData {
  trackingData: TrackingData;
  utmParameters: UtmParameterValues;
}

// Lead source tracking parameters we capture from the URL.
// Will be part of the submitted application data.
export interface UtmParameterValues {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  gclid?: string;
  fbclid?: string;
  referrer?: string;
  landing_page?: string;
  form_page?: string;
  initialSiteVisitTimestamp?: string;
  returnSiteVisitTimestamp?: string;
}

export const defaultLeadSourceParameters: LeadSourceTrackingData = {
  trackingData: {
    trackingId: "",
    trackingEvents: [],
  },
  utmParameters: {
    utm_source: undefined,
    utm_medium: undefined,
    utm_campaign: undefined,
    utm_term: undefined,
    utm_content: undefined,
    gclid: undefined,
    fbclid: undefined,
    referrer: undefined,
    landing_page: undefined,
    form_page: undefined,
    initialSiteVisitTimestamp: undefined,
    returnSiteVisitTimestamp: undefined,
  },
};
